<template>
  <a-card :bordered='false' style="width: 100%">
    <div v-if="extractHtml!=='' && !stampShowed" >
      <SignFileShow :sectionId='sectionId' :type='pdfParams.type'></SignFileShow>
    </div>
    <div v-show="!stampShowed">
      <div  v-show="!showFlag" id="pdfCentent">
        <h2 style="text-align: center">评标基准价计算方法抽取</h2>
        <a-spin tip="加载中......" :spinning="false">
          <div style='border-left: #000 1px solid;border-top: #000 1px solid'>
            <div>
              <a-row>
                <a-col :span="6" >
                  计算方法
                </a-col>
                <a-col :span="9" >
                  方法一
                </a-col>
                <a-col :span="9" >
                  方法二
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="6" >
                  对应球号
                </a-col>
                <a-col v-for="v,index in way" :span="9" >
                  <a-input-number
                    v-if='v == 1'
                    v-model='ball[index]'
                    style="margin: -5px 0"
                    @change="e => handleBallChange(e, index)"
                  />
                  <span v-if='v == 0'>/</span>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="6" >
                  抽中球号
                </a-col>
                <a-col :span="18" >
                  <a-input-number
                    style="margin: -5px 0"
                    v-model='extractBall'
                    @change="e => handle(e)"
                  />
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="6" >
                  对应方法
                </a-col>
                <a-col :span="18" >
                  {{ extractTypeZh }}
                </a-col>
              </a-row>
            </div>
          </div>
        </a-spin>
      </div>
    </div>
    <h2 align="center" style="margin-top: 10px">
      <a-button type="primary" style="margin-right: 10px" @click="prevStep">上一步</a-button>
      <span v-show="showFlag && !stampShowed">
        <a-button type="primary" style="margin-right: 10px" @click="reEdit()">重新抽取</a-button>
      </span>
      <span v-show="!stampShowed && !showFlag && this.extractTimes != 1">
        <a-button type="primary" style="margin-right: 10px" @click="cancle()">取消</a-button>
      </span>
      <SignatureButton
        v-show="!stampShowed"
        ref="SignatureButton"
        :pdf-params="pdfParams"
        :stampShowed="stampShowed"
        :disabled="showFlag"
        @sign="sign"
        @signShow="signShow"
      ></SignatureButton>
      <a-button type="primary" style="margin-left: 10px" :disabled="showFlag" @click="okHandle()">提交</a-button>
      <a-button type="primary" :disabled="!showFlag" style="margin-left: 10px" v-print="'#printContent'">打印</a-button>
      <a-button type="primary" :disabled="!showFlag" style="margin-left: 10px" @click="nextStep">下一步</a-button>
    </h2>
    <SignatureComponent
      v-show="stampShowed"
      ref="stamp"
      :pdf-params="pdfParams"
      @checkStampForm="checkStampForm"
      @changeIsStamp="changeIsStamp"
    ></SignatureComponent>
    <SignFileShow-modal ref="modalForm"></SignFileShow-modal>
  </a-card>
</template>

<script>
import { postAction, getAction } from '@api/manage'
import stamp from '@/components/Stamp'
import WorkChangeStamp from '@/components/WorkChangeStamp'
import SignatureComponent from '@/components/SignatureComponent'
import SignatureButton from '@/components/SignatureButton'
import SignFileShowModal from '../../modules/SignFileShowModal'
import numeral from 'numeral'
import { toHtml }  from '@/utils/htmlUtil'
import SignFileShow from '@views/bobidopen/modules/SignFileShow.vue'
export default {
  name: 'WaterTransportBenchmarkPriceComputeStep3',
  components: { SignFileShow, WorkChangeStamp, stamp ,SignatureComponent,SignatureButton,SignFileShowModal },
  mixins: [],
  data() {
    return {
      way:null,
      ball:null,
      extractBall:null,
      extractType:null,
      extractHtml: "",
      showFlag: true,
      extractTimes: "",
      //以下签章需要-----------------------
      isStamp: true,
      pdfParams: {
        pageId:"",
        signedPdfUrl: "",
        bidProjectId: '1',
        sectionId: '1',
        type: 'BenchmarkPriceWay',
        typeZh: '评标基准价计算方法抽取表签章',
        htmlTitle: '评标基准价计算方法抽取表签章',
        fp: '4',
        saveTmFileFlag:'1',
        signType:'1'//1:统一CA，2：工改签章
      },
      stampShowed: false,
      // disableMixinCreated: true,
    }
  },
  props: ['sectionId','bidProjectId'],
  created() {
    this.pdfParams.bidProjectId = this.bidProjectId
    this.pdfParams.sectionId = this.sectionId
    this.getExtractResult();
    this.getExtractWay ();
  },
  computed: {
    extractTypeZh() {
      switch(this.extractType) {
      case 1:
        return "方法一";
      case 2:
        return "方法二";
      }
    }
  },
  methods: {
    handleBallChange(v , index) {
      this.extractBall = null;
      this.extractType = null;
      for (let i = 0; i < this.ball.length; i++) {
        if( v == this.ball[i] && index != i) {
          this.ball[index] = null
          // this.$message.warning("对应代表球号重复，请重新填写！")
          return
        }
      }
      this.ball[index] = v;
    },
    handle(v) {
      for (let i = 0; i < this.ball.length; i++) {
        if(this.ball[i] == v) {
          this.extractType = i+1;
          return
        }
      }
      this.extractBall = null;
      this.extractType = null;
      // this.$message.warning("对应代表球号不存在，请重新填写！")
    },
    okHandle() {
      for (let i = 0; i < this.ball.length; i++) {
        if(this.way[i] == 1 && (this.ball[i] === "" || this.ball[i] == null) ) {
          this.$message.warning("对应代表球号存在空值，请重新填写！")
          return
        }
      }
      if(this.extractBall == null || this.extractBall === "" || this.extractType ==="" || this.extractType == null) {
        this.$message.warning("抽取球号为空，请重新填写！")
        return
      }

      if (this.$refs.stamp.getPdfUrl() == null) {
        this.$message.info('请先签章')
        return
      }

      let that = this;
      let params ={};
      params.aball = this.ball[0];
      params.bball = this.ball[1];
      params.extractBall = this.extractBall;
      params.extractType = this.extractType;
      params.extractTimes = this.extractTimes;
      params.pdfUrl = this.$refs.stamp.getPdfUrl()
      params.type = this.pdfParams.type
      params.typeZh = this.pdfParams.typeZh
      params.resultHtml =  toHtml('pdfCentent')
      postAction('/ebid-ce/waterTransportBenchmarkPriceCompute/saveExtractResult/' + this.bidProjectId + "/" + this.sectionId, params).then((res) => {
        if (res.success) {
          that.extractHtml = params.resultHtml;
          that.showFlag=true;
          that.$message.success(res.result)
        } else {
          that.$message.warning(res.message)
        }
      })
    },
    //获取需要抽取的抽取办法列表
    getExtractWay () {
      let initWay = new Array(2);
      let initBall = new Array(2);
      initWay[0] = 1;
      initBall[0] = null;
      initWay[1] = 1;
      initBall[1] = null;

      this.way = initWay;
      this.ball = initBall;
    },
    //获取抽取结果
    getExtractResult() {
      getAction('/ebid-ce/waterTransportBenchmarkPriceCompute/getBenchmarkWayResult/' + this.sectionId, {}).then((res) => {
        if (res.success) {
          if(res.result.length > 0) {
            this.extractHtml = res.result[0].resultHtml;
            this.extractTimes = res.result.length;
          } else {
            this.showFlag = false;
            this.extractTimes = 1;
          }
        }else {
          this.$message.warning(res.message)
        }
      })
    },
    reEdit() {
      this.showFlag = false
      this.extractTimes += 1
      this.extractHtml=''
    },
    cancle() {
      this.showFlag = true
      this.extractTimes += -1
      this.extractHtml='1'
    },
    /**
     * 签章入围企业
     */
    sign(type) {
      for (let i = 0; i < this.ball.length; i++) {
        if(this.way[i] == 1 && (this.ball[i] === "" || this.ball[i] == null) ) {
          this.$message.warning("对应代表球号存在空值，请重新填写！")
          return
        }
      }
      if(this.extractBall == null || this.extractBall === "" || this.extractType ==="" || this.extractType == null) {
        this.$message.warning("抽取球号为空，请重新填写！")
        return
      }

      this.pdfParams.signType = type;
      let that = this
      this.$confirm({
        title: '提示',
        content: '您确定要进行签章操作吗？',
        onOk() {
          //设置本页面标识，用于redis key记录当前页面签章信息
          that.pdfParams.pageId = that.sectionId + "_extractWay_" + new Date().getTime();
          that.$refs.stamp.checkStamp()
        },
        onCancel(){
          that.pdfParams.pageId="";
          that.pdfParams.signedPdfUrl="";
          that.stampShowed = false;
          that.$refs.stamp.pdfUrl=null;
        },
      })
    },
    //签章文件查看
    signShow() {
      this.$refs.modalForm.show(this.sectionId,this.pdfParams.type);
    },
    //重新编辑
    reWrite(){
      this.pdfParams.pageId="";
      this.pdfParams.signedPdfUrl="";
      this.stampShowed = false;
      this.$refs.stamp.pdfUrl=null;
    },
    // getSignedPdf(){
    //   let that = this;
    //   that.$confirm({
    //     title: '确认信息',
    //     content: '请确认是否已经完成签章，未完成则先完成签章，完成则点击确认获取签章文件！',
    //     onOk() {
    //       that.$refs.stamp.getPdfUrl();
    //     },
    //     onCancel(){
    //     },
    //   })
    // },
    checkStampForm(callback) {
      callback(true)
    },
    changeIsStamp(val) {
      this.stampShowed = val
    },
    /**
     * 千分位数字
     * @param num
     */
    thousandthNumber(num){
      return numeral(num).format('0,0.00')
    },
    prevStep () {
      this.$emit('prevStep')
    },
    nextStep () {
      this.$emit('nextStep')
    },
  },
}
</script>

<style scoped>
@import '~@assets/less/common.less';

.ant-row {

}
.ant-col {
  border-bottom: #000 1px solid;
  border-right: #000 1px solid;
  height: 50px;
  /*display: flex;*/
  display: -webkit-box; /* wkhtmltopdf uses this one */
  align-items:center;
  justify-content:center;
  -webkit-box-pack: center!important;; /* wkhtmltopdf uses this one */
  -webkit-box-align: center!important;
}

.ant-input-number-input {
  margin: -5px 0;
}
</style>